"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BluetoothClient_1 = __importDefault(require("../bluetoothClient/BluetoothClient"));
var DeviceCharacteristic_1 = require("./DeviceCharacteristic");
var Features = __importStar(require("../features"));
var features_1 = require("../features");
var FeatureNotAvailable_1 = __importDefault(require("../exceptions/FeatureNotAvailable"));
/* eslint-disable no-underscore-dangle */
var BatDevice = /** @class */ (function (_super) {
    __extends(BatDevice, _super);
    function BatDevice(settings, type) {
        var _this = _super.call(this, settings) || this;
        _this.ConnectionState = features_1.ConnectionState;
        _this.MSSProgressState = features_1.MSSProgressState;
        _this.FirmwareManager = features_1.FirmwareManager;
        _this.getDevice = function () {
            return _this;
        };
        _this._UUID = settings.uuid;
        _this.profile = settings;
        _this._type = type;
        return _this;
    }
    BatDevice.prototype.isFeatureAvailable = function (service, feature) {
        return __awaiter(this, void 0, void 0, function () {
            var featureExist, batService, batCharacteristic, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        // Check if service is on device profile or not.
                        if (!this._batSettings[service]) {
                            return [2 /*return*/, false];
                        }
                        featureExist = this._batSettings[service].characteristics.filter(function (c) { return c.name === feature; });
                        if (featureExist.length <= 0) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this._server.getPrimaryService(this._batSettings[service].uuid)];
                    case 1:
                        batService = _a.sent();
                        return [4 /*yield*/, batService.getCharacteristic(featureExist[0].uuid)];
                    case 2:
                        batCharacteristic = _a.sent();
                        return [2 /*return*/, !!batCharacteristic];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BatDevice.prototype.checkFeatureAvailability = function (service, feature) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.isFeatureAvailable(service, feature)];
                    case 1:
                        if (!(_a.sent())) {
                            throw new FeatureNotAvailable_1.default(feature);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BatDevice.prototype.getBatteryInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BATTERY).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getBatteryInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getBleTimeoutInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BLE_TIMEOUT).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getBleTimeoutInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.setBleTimeoutInfo = function (timeoutToSet, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BLE_TIMEOUT).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setBleTimeoutInfo(this, timeoutToSet, withResponse)];
                }
            });
        });
    };
    BatDevice.prototype.getAVChallengeInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.AGE_VERIFICATION, DeviceCharacteristic_1.AVCharacteristics.CHALLENGE_GENERATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getAVChallengeInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getAVSignatureInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.AGE_VERIFICATION, DeviceCharacteristic_1.AVCharacteristics.SIGNATURE_VERIFICATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getAVSignatureInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.setAVSignatureInfo = function (message, signature, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.AGE_VERIFICATION, DeviceCharacteristic_1.AVCharacteristics.SIGNATURE_VERIFICATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setAVSignatureInfo(this, message, signature, withResponse)];
                }
            });
        });
    };
    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line class-methods-use-this
    BatDevice.prototype.setConnectionStateChanged = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Features.setConnectionStateChanged(this, callback)];
            });
        });
    };
    BatDevice.prototype.setMSSProgressStateChanged = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Features.setMSSProgressStateChanged(this, callback)];
            });
        });
    };
    BatDevice.prototype.setMSSPayloadUploadStateChanged = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Features.setPayloadUploadStateChanged(this, callback)];
            });
        });
    };
    BatDevice.prototype.mssProgressChanged = function (mssProgressState) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.mssSetupProgressChanged(mssProgressState);
                return [2 /*return*/];
            });
        });
    };
    BatDevice.prototype.payloadUploadChanged = function (progressState) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.payloadUploadProgressChanged(progressState);
                return [2 /*return*/];
            });
        });
    };
    BatDevice.prototype.getDeviceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getDeviceInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getDeviceMSSPayload = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getDeviceMSSPayload(this)];
                }
            });
        });
    };
    BatDevice.prototype.getDateTimeInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.TIME).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getDateTimeInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getLockInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.LOCK).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getLockInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getLedInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.LED).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getLedInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getFindVapeInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.FIND_MY_VAPE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getFindVapeInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.setDateTimeConfig = function (unixTime, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.TIME).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setDateTimeConfig(this, unixTime, withResponse)];
                }
            });
        });
    };
    BatDevice.prototype.getCloudInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getCloudInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.isAdvNameExisting = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.isAdvNameExisting(this)];
                }
            });
        });
    };
    BatDevice.prototype.isBSExisting = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.isBSExisting(this)];
                }
            });
        });
    };
    BatDevice.prototype.getHapticInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.HAPTIC).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getHapticInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getErrorRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.LOG, DeviceCharacteristic_1.LogCharacteristics.LAST_ERROR).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getErrorRecord(this)];
                }
            });
        });
    };
    BatDevice.prototype.writeInfoCode = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.writeInfoCode(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.writeAdvName = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.writeAdvName(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.setLockConfig = function (value, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.LOCK).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setLockConfig(this, value, withResponse)];
                }
            });
        });
    };
    BatDevice.prototype.setLedConfig = function (value, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.LED).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setLedConfig(this, value, withResponse)];
                }
            });
        });
    };
    BatDevice.prototype.setCloudConfig = function (powerLevel, batterySavingEnabled, batterySavingThresholdValue, batterySavingPowerLevel, batterySavingOn, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setCloudConfig(this, powerLevel, batterySavingEnabled, batterySavingThresholdValue, batterySavingPowerLevel, batterySavingOn, withResponse)];
                }
            });
        });
    };
    BatDevice.prototype.setHapticInfo = function (value, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.HAPTIC).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setHapticConfig(this, value, withResponse)];
                }
            });
        });
    };
    BatDevice.prototype.setPayload = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.PAYLOAD).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setPayload(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.getLoadedCharacteristics = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        resolve(Features.getLoadedCharacteristics(_this, _this.characteristics));
                    })];
            });
        });
    };
    BatDevice.prototype.characteristicExists = function (characteristicUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        resolve(Features.characteristicExists(_this, characteristicUuid));
                    })];
            });
        });
    };
    BatDevice.prototype.setPayloadVersion = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.VERSION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setPayloadVersion(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.setPayloadControl = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setPayloadControl(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.setPayloadChallenge = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.CHALLENGE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setPayloadChallenge(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.setMarketSpecificSoftware = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.PAYLOAD).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setMarketSpecificSoftware(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.requestPayload = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.PAYLOAD).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.requestPayload(value)];
                }
            });
        });
    };
    BatDevice.prototype.parsePayload = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.PAYLOAD).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.parsePayload(value)];
                }
            });
        });
    };
    BatDevice.prototype.uploadPayload = function (device) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.PAYLOAD).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.uploadPayload(device)];
                }
            });
        });
    };
    BatDevice.prototype.toggleFindMyVape = function (value, soundPattern) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.FIND_MY_VAPE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.toggleFindMyVape(this, value, soundPattern)];
                }
            });
        });
    };
    BatDevice.prototype.createDummyRecords = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.createDummyRecords(this, value)];
                }
            });
        });
    };
    BatDevice.prototype.deletePuffRecords = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.deletePuffRecords(this)];
                }
            });
        });
    };
    BatDevice.prototype.getPuffRecord = function (parseDate) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getPuffRecord(this, parseDate)];
                }
            });
        });
    };
    BatDevice.prototype.setReset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.FACTORY_RESET).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setReset(this)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToDeviceInfo = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToDeviceInfo(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToBatteryInfo = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BATTERY).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToBatteryInfo(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToCloud = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToCloud(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToPayloadControl = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToPayloadControl(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToPayloadChallenge = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.CHALLENGE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToPayloadChallenge(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToErrorRecord = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.LOG, DeviceCharacteristic_1.LogCharacteristics.LAST_ERROR).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToErrorRecord(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToLogRecord = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.LOG, DeviceCharacteristic_1.LogCharacteristics.LOG_RECORD).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToLogRecord(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToPuffRecord = function (listener, parseDate) {
        if (parseDate === void 0) { parseDate = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToPuffRecord(this, parseDate, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToFindVapeInfo = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.FIND_MY_VAPE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToFindVapeInfo(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToLockInfo = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.LOCK).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToLockInfo(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromErrorRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.LOG, DeviceCharacteristic_1.LogCharacteristics.LAST_ERROR).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromErrorRecord(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromCloud = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromCloud(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromLogRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.LOG, DeviceCharacteristic_1.LogCharacteristics.LOG_RECORD).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromLogRecord(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromPayloadChallenge = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.CHALLENGE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromPayloadChallenge(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromPayloadControl = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.DEVICE_MANAGEMENT, DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromPayloadControl(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromPuffRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromPuffRecord(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromFindVapeInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.FIND_MY_VAPE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromFindVapeInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromBatteryInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BATTERY).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromBatteryInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromDeviceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BATTERY).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromDeviceInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromLockInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.LOCK).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromLockInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getBuzzerInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BUZZER).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getBuzzerInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.setBuzzerConfig = function (value, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.BUZZER).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setBuzzerConfig(this, value, withResponse)];
                }
            });
        });
    };
    BatDevice.prototype.getPodConnectionStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POD_CONNECTION_DETECTION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getPodConnectionStatus(this)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToPodConnectionStatus = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POD_CONNECTION_DETECTION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToPodConnectionStatus(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeFromPodConnectionStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POD_CONNECTION_DETECTION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeFromPodConnectionStatus(this)];
                }
            });
        });
    };
    BatDevice.prototype.isManualAutoModeAvailable = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Features.isManualAutoModeAvailable(this)];
            });
        });
    };
    BatDevice.prototype.getPodInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POD_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getPodInformation(this)];
                }
            });
        });
    };
    BatDevice.prototype.subscribeToPodInformation = function (listener) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POD_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.subscribeToPodConnectionInfo(this, listener)];
                }
            });
        });
    };
    BatDevice.prototype.unsubscribeToPodInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POD_INFORMATION).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.unsubscribeToPodConnectionInfo(this)];
                }
            });
        });
    };
    BatDevice.prototype.getPowerSaveModeInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POWER_SAVER_MODE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.getPowerSaveModeStatus(this)];
                }
            });
        });
    };
    BatDevice.prototype.setPowerSaveModeConfig = function (value, withResponse) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkFeatureAvailability(DeviceCharacteristic_1.BATServices.VAPING, DeviceCharacteristic_1.VapingCharacteristics.POWER_SAVER_MODE).catch(function (e) { return e; })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Features.setPowerSaveMode(this, value, withResponse)];
                }
            });
        });
    };
    Object.defineProperty(BatDevice.prototype, "UUID", {
        get: function () {
            return this._UUID;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BatDevice.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BatDevice.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BatDevice.prototype, "parsedPayload", {
        get: function () {
            return this._parsedPayload;
        },
        set: function (value) {
            this._parsedPayload = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BatDevice.prototype, "payloadUploadState", {
        get: function () {
            return this._payloadUploadState;
        },
        set: function (value) {
            this._payloadUploadState = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BatDevice.prototype, "controlCode", {
        get: function () {
            return this._controlCode;
        },
        set: function (value) {
            this._controlCode = value;
        },
        enumerable: false,
        configurable: true
    });
    BatDevice.prototype.getBleDevice = function () {
        return this._device;
    };
    return BatDevice;
}(BluetoothClient_1.default));
exports.default = BatDevice;
